define('bindingHandlers/accordion2/animateAccordion',[
    'jquery',
    'lib/lodash4',
    'lib/knockout'
], function ($, _, ko) {
    'use strict';

    var ANIMATE_OPEN_CLASS = 'accordion-animate-open';
    var ANIMATE_CLOSED_CLASS = 'accordion-animate-closed';

    var addIsOpenClass = function ($element) {
        $element.addClass('is-open');
        $element.removeClass('is-closed');
    };

    var addIsClosedClass = function ($element) {
        $element.addClass('is-closed');
        $element.removeClass('is-open');
    };

    ko.bindingHandlers.animateAccordion = {
        init: function (element, valueAccessor) {
            var value = valueAccessor();
            var accordionItem = element.parentElement;

            // initialize the open/closed classes
            if (!value()) {
                addIsClosedClass($(accordionItem));
            } else {
                addIsOpenClass($(accordionItem));
            }

            // add the animation class when value changes
            var subscribedValue = value.subscribe(function(newValue) {
                if (newValue) {
                    $(accordionItem).addClass(ANIMATE_OPEN_CLASS);
                    addIsOpenClass($(accordionItem));
                } else {
                    $(accordionItem).addClass(ANIMATE_CLOSED_CLASS);
                    addIsClosedClass($(accordionItem));
                }
            });

            // remove the css animation when it finishes
            $(accordionItem).on('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', function() {
                if (!_.includes(accordionItem.classList, 'accordion-animate-open')) {
                    $(accordionItem).removeClass(ANIMATE_CLOSED_CLASS);
                } else {
                    $(accordionItem).removeClass(ANIMATE_OPEN_CLASS);
                }
            });

            // toggle the value when the accordion item is clicked
            $(element).on('click', function (event) {
                value(!value());
                event.preventDefault();
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                subscribedValue.dispose();
                var parent = element.parentElement;
                $(element).off('click');
                $(parent).off('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd');
            });
        }
    };

});

